export default "__VITE_ASSET__BDkvgZAo__"